import { RadioChangeEvent, RadioGroupField } from "@dgs/core";
import { useField } from "formik";
import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { AppNotificationActionType } from "../shared/types/appNotification";
import { RecipientType } from "../shared/types/recipient";

interface Props {
	onChange?: (e: RadioChangeEvent) => void;
	disabled?: boolean;
}

export const AppNotificationActionTypeSelect: FC<Props> = (props) => {
	const { t } = useTranslation();
	const [recipientTypeField] = useField("recipientType");
	const [field] = useField("actionType");

	const isParticipantManagementContacts = recipientTypeField.value === RecipientType.PARTICIPANT_MANAGEMENT_CONTACTS;
	const baseOptions = [
		{ name: t("No action"), value: AppNotificationActionType.NONE },
		{ name: t("Open tab"), value: AppNotificationActionType.OPEN_TAB },
		{ name: t("Open event"), value: AppNotificationActionType.OPEN_EVENT },
		{ name: t("Open website"), value: AppNotificationActionType.OPEN_WEBSITE },
	];

	useEffect(() => {
		if (!isParticipantManagementContacts && field.value === AppNotificationActionType.REGISTRATION_LINK) {
			field.onChange({ target: { name: field.name, value: AppNotificationActionType.NONE } });
		}
	}, [field, isParticipantManagementContacts]);

	return (
		<RadioGroupField
			name={field.name}
			label={t("Action")}
			options={
				isParticipantManagementContacts
					? baseOptions.concat({ name: t("Invitation link"), value: AppNotificationActionType.REGISTRATION_LINK })
					: baseOptions
			}
			{...props}
		/>
	);
};
